import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { Allocation } from '@lib/models/generated/graphql';
import { AbstractPaginatedTableComponent } from 'finzzle-angular-utils';
import { Subscription } from 'rxjs';
import { AllocationColumn } from 'src/app/components/admin-page/admin-fichiers-allocation/allocation-table/allocation-column';

@Component({
  selector: 'app-allocation-table',
  templateUrl: './allocation-table.component.html',
  styleUrls: ['./allocation-table.component.scss'],
})
export class AllocationTableComponent extends AbstractPaginatedTableComponent<Allocation> {
  @ViewChildren('configSort') configSortsort: QueryList<MatSort>;
  @Input({ required: true })
  columnSelection: AllocationColumn[] = [];

  @Input({ required: true })
  displayedColumns: string[];

  @Output()
  onRowClick = new EventEmitter<Allocation>();

  sortActive?: string;
  sortDirection?: string;
  sortSub: Subscription | undefined;

  constructor(private datePipe: DatePipe) {
    super();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.sortSub?.unsubscribe();
  }
  override ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.sortSub = this.configSortsort.changes.subscribe((res: QueryList<MatSort>) => {
      if (res.first) {
        this.dataSource.sort = res.first;
        this.dataSource.sortingDataAccessor = (data: Allocation, headerId: string) => {
          switch (headerId) {
            case 'Mise à jour':
              return data.dateModification ?? '';
            case "Nom de l'allocation":
              return data.libelle ?? '';
            default:
              return '';
          }
        };
      }
    });
  }

  rowClick(selected: Allocation) {
    this.onRowClick.emit(selected);
  }

  displayColumnInfo(column: AllocationColumn, allocation: Allocation) {
    return column.getData(allocation, this.datePipe);
  }
}
